export default function getScenarioName(scenarioIndex, language) {
  if (language === 'en') {
    return `S${scenarioIndex}`;
  } else if (language === 'es') {
    return `E${scenarioIndex}`;
  } else {
    return `${scenarioIndex}`;
  }
}
